module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row3"
  }, [_c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ChaSearchPerson',
        query: {}
      }),
      expression: "{name:'ChaSearchPerson',query:{}}"
    }],
    attrs: {
      "src": require("../../../assets/images/bg-search-persion.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ChaSearchDanwei',
        query: {}
      }),
      expression: "{name:'ChaSearchDanwei',query:{}}"
    }],
    attrs: {
      "src": require("../../../assets/images/bg-search-danwei.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'NewsList',
        query: {
          cate_id: 71
        }
      }),
      expression: "{name:'NewsList',query:{cate_id:71}}"
    }],
    attrs: {
      "src": require("../../../assets/images/bg-search-download.png")
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ChaSearchAll',
        query: {}
      }),
      expression: "{name:'ChaSearchAll',query:{}}"
    }],
    staticClass: "search"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/icon_search.png"),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_vm._v("全局搜索")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14ef7de6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/cha/SearchIndex.vue
// module id = 1383
// module chunks = 0